export function shuffleArray(array: any[]) {
  const arrayCopy = [...array]
  for (let i = arrayCopy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[arrayCopy[i], arrayCopy[j]] = [arrayCopy[j], arrayCopy[i]]
  }

  return arrayCopy
}

export function shuffleArrayExceptLast(array: any[]) {
  const arrayCopy = [...array]
  const lastIndex = arrayCopy.length - 1
  const lastElement = arrayCopy[lastIndex]

  for (let i = lastIndex - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * i)
    ;[arrayCopy[i], arrayCopy[j]] = [arrayCopy[j], arrayCopy[i]]
  }

  arrayCopy[lastIndex] = lastElement // Place the last element back in its original position
  return arrayCopy
}

export function shuffleArrayExceptLastTwo(array: any[]) {
  const arrayCopy = [...array]
  const lastTwoIndex = arrayCopy.length - 3 // Индекс первого из последних трёх элементов

  // Перемешиваем элементы, за исключением последних трёх
  for (let i = lastTwoIndex - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * i)
    ;[arrayCopy[i], arrayCopy[j]] = [arrayCopy[j], arrayCopy[i]]
  }

  return arrayCopy
}
